import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DensitySmallIcon(props: IconProps) {
    return <Icon {...props} iconKey={"density_small"}/>
}
